"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskSelectionCheckbox = TaskSelectionCheckbox;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
/** Must render inside a Table column or row: the table's selection context drives its state. */
function TaskSelectionCheckbox(props) {
    var ariaLabel = props.ariaLabel;
    return ((0, jsx_runtime_1.jsx)(react_1.Checkbox, { slot: "selection", "aria-label": ariaLabel, children: (0, jsx_runtime_1.jsx)(react_1.Checkbox.Control, { children: (0, jsx_runtime_1.jsx)(react_1.Checkbox.Indicator, { children: function (_a) {
                    var isIndeterminate = _a.isIndeterminate;
                    return (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: isIndeterminate ? "solar:minus-square-linear" : "solar:check-read-linear", fontSize: 12 });
                } }) }) }));
}
